<mat-dialog-content>
  <p>Płatności kartą oraz funkcja autopłatności są tymczasowo niedostępne.</p>
  <p>
    By dowiedzieć się więcej kliknij
    <a
      href="https://payappka.document360.io/docs/najczestsze-powody-odrzucenia-p%C5%82atnosci-karta-dlaczego-tak-mog%C5%82o-sie-stac"
      target="_blank"
      >tutaj</a
    >
  </p>
</mat-dialog-content>

<mat-dialog-actions align="start">
  <button (click)="close()" mat-button>Zamknij</button>
</mat-dialog-actions>
